const dayjs = require('dayjs');
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');

// โหลดปลั๊กอิน
dayjs.extend(utc);
dayjs.extend(timezone);

exports.isWithinWorkingHours = (workingHours, requestTimestamp) => {

    if(Object.keys(workingHours).length > 0){
        //หากมีการกำหนด time ต้องตรวจสอบเวลา
        const dt = requestTimestamp ? dayjs(requestTimestamp) : dayjs().tz("Asia/Bangkok");
        // console.log("requestTimestamp:", dt)
        const day = dt.format("dddd").toLowerCase(); // เช่น "monday"
        const timeStr = dt.format("HH:mm"); // เช่น "10:45"

        const todaySchedule = workingHours[day];

        if (!todaySchedule) {
            // ไม่มีการกำหนด time สำหรับวันนี้
            return false;
        }
      
        return todaySchedule.some(({ start, end }) => {
            return timeStr >= start && timeStr <= end;
        });
    }
    else{
        //หากไม่มีการกำหนด time ถือว่าอนุญาตทั้งหมด
        return true;
    }
    
  }